import React, { useState, useCallback, useRef } from 'react';
import { ASSET_TYPE } from '../react-three-components/sceneAsset';
import { positionalAudiosPack } from '../assets/positionalAudiosPack';
import {
  SoundOutlined,
  PlayCircleOutlined,
  PauseCircleOutlined,
} from '@ant-design/icons';
import styles from '../add-to-scene.module.css';

export default function AudioContent({ onAddToScene }) {
  const [playingAudio, setPlayingAudio] = useState<string | null>(null);
  const audioRef = useRef<HTMLAudioElement | null>(null);

  const handleAudioClick = (audio) => {
    onAddToScene({
      type: ASSET_TYPE.MISC.POSITIONAL_AUDIO,
      url: audio.url,
      name: audio.name,
      ref: React.createRef(),
      distance: 20,
    });
  };

  const handlePlayClick = useCallback(
    (audio, event) => {
      event.stopPropagation();

      const audioUrl = audio.url;

      if (playingAudio === audioUrl) {
        if (audioRef.current) {
          audioRef.current.pause();
          audioRef.current.currentTime = 0;
        }
        setPlayingAudio(null);
        return;
      }

      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }

      const newAudio = new Audio(audioUrl);
      newAudio.addEventListener('ended', () => {
        setPlayingAudio(null);
      });

      newAudio.play();
      audioRef.current = newAudio;
      setPlayingAudio(audioUrl);
    },
    [playingAudio]
  );

  return (
    <div className={styles.gridContainer}>
      {positionalAudiosPack.map((audio, index) => {
        const isPlaying = playingAudio === audio.url;

        return (
          <div
            key={`${index}-${audio.name}`}
            className={styles.libraryItem}
            onClick={() => handleAudioClick(audio)}
          >
            <div className={styles.libraryThumbnail}>
              <div className={styles.audioThumbnail}>
                <SoundOutlined className={styles.audioIcon} />
              </div>
            </div>

            <div
              className={styles.previewIcon}
              onClick={(e) => handlePlayClick(audio, e)}
              title={isPlaying ? 'Stop' : 'Preview'}
              style={{ opacity: 1 }}
            >
              {isPlaying ? <PauseCircleOutlined /> : <PlayCircleOutlined />}
            </div>

            <div className={styles.libraryItemName}>{audio.name}</div>

            <button
              className={styles.addToSceneButton}
              onClick={(e) => {
                e.stopPropagation();
                handleAudioClick(audio);
              }}
            >
              Add to scene
            </button>
          </div>
        );
      })}
    </div>
  );
}
